import axios from "axios";
import axiosInstance from "./axiosInstance";

// const BASE_URL = "http://10.200.39.222:8000";
const BASE_URL = "https://api.themailwhale.in";
// const BASE_URL = "http://10.200.39.100:8080";

// ✅ Uses interceptor — Authorization header is added automatically
export const logoutResident = async (refresh) => {
  try {
    const response = await axiosInstance.post(
      "/api/accounts/resident/logout/",
      {
        refresh,
      },
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error during logout:",
      error?.response?.data || error.message,
    );
    throw error;
  }
};

export const fetchResidentDeliveriesAPI = async ({
  phone,
  location,
  complex,
}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/mobile/resident/test-deliveries/`,
      {
        phone,
        location,
        complex,
      },
    );

    return response.data;
  } catch (error) {
    const statusCode = error.response?.status;
    console.error("Error fetching resident deliveries:");
    console.error("Status Code:", statusCode);
    console.error("Response Data:", error.response?.data || error.message);

    // If status is 404, return the error data gracefully instead of throwing
    if (statusCode === 404) {
      return error.response?.data || { error: "Not Found" };
    }

    throw error;
  }
};

export const fetchResidentProfile = async () => {
  try {
    console.log("📤 Fetching resident profile...");

    const response = await axiosInstance.get("/api/mobile/resident/profile/");

    return response.data;
  } catch (error) {
    console.error("❌ Failed to fetch resident profile.");
    console.error("❗ Error details:", error.response?.data || error.message);
    throw error;
  }
};

// ─── Fetch Pre-Approved Parcels ─────────────────────────────────────────────
export const fetchPreApprovedAPI = async (resident_id) => {
  try {
    // GET request to /api/mobile/resident/pre-approve/?resident_id=<id>
    const response = await axios.get(
      `${BASE_URL}/api/mobile/resident/pre-approve/?resident_id=${resident_id}`,
    );
    // The endpoint returns { success: true, data: [ … ] }, so we return the inner array:
    // console.log("✅ fetchPreApprovedAPI Response:", response.data);

    return response.data || [];
  } catch (error) {
    // console.error(
    //   "❌ Pre-Approved Fetch Error:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

// Approve or Deny Parcel (Send "True" or "False" as string)
export const approveOrDenyParcel = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/mobile/resident/approve/`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error(
      ":x: Parcel Approval Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
// ─── Cancel (DELETE) a Pre-Approved Parcel ─────────────────────────────────
export const cancelPreApproval = async (approvalId) => {
  try {
    // If this endpoint requires authentication, axiosInstance will

    const response = await axios.delete(
      `${BASE_URL}/api/mobile/resident/pre-approve-parcel/${approvalId}/`,
    );
    // console.log("✅ Cancel Pre-Approval Response:", response.data);
    return response.data;
  } catch (error) {
    // console.error(
    //   "❌ Cancel Pre-Approval Error:",
    //   error.response?.data || error.message
    // );
    throw error;
  }
};

//─── Add Member ───────────────
export const addSecondaryMember = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/api/mobile/resident/add-secondary-member/`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("❌ API error:", error.response?.data || error.message);
    throw error;
  }
};

// ─── Fetch New secondary Members List ─────────────────────────────────
export const fetchMemberListAPI = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/api/mobile/members/`);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Error fetching member list:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
// PATCH request to update resident profile
export const patchResidentProfile = async (updatedData) => {
  try {
    const response = await axiosInstance.patch(
      `${BASE_URL}/api/mobile/resident/profile/`,
      updatedData,
    );
    // console.log("✅ Profile updated:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Profile update error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Pre-Approve Parcel (No Authorization Required)
export const submitPreApproval = async (data) => {
  try {
    // Debug: Log all form data entries
    console.log("📦 FormData Contents:");
    for (const pair of data.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Debug: Log headers
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    console.log("🧾 Headers:", headers);

    const response = await axiosInstance.post(
      `${BASE_URL}/api/mobile/resident/pre-approve/`,
      data,
      {
        headers,
      },
    );

    console.log("✅ Pre-Approval Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Pre-Approval Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// 1) Create Razorpay Order
export const createRazorpayOrder = async (
  amount = 1.0,
  planName = "",
  residentName,
  residentPhone,
  residentEmail, // optional; can pass "" if not used
) => {
  const payload = {
    amount,
    plan_name: planName,
    resident_name: residentName,
    resident_phone: residentPhone,
    resident_email: residentEmail,
  };

  console.log("🟦 [createRazorpayOrder] POST payload:", payload);

  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/api/accounts/resident/payment/create-order/`,
      payload,
    );
    console.log("🟩 [createRazorpayOrder] response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "🟥 [createRazorpayOrder] error:",
      error.response?.data || error,
    );
    return { success: false, error };
  }
};

// 2) Verify Razorpay Payment
export const verifyRazorpayPayment = async (payload, accessToken) => {
  console.log("🟦 [verifyRazorpayPayment] POST payload:", payload);
  console.log("🔐 [verifyRazorpayPayment] token:", accessToken);

  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/api/accounts/resident/payment/verify-payment/`,
      payload,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    console.log("🟩 [verifyRazorpayPayment] response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "🟥 [verifyRazorpayPayment] error:",
      error.response?.data || error,
    );
    return error.response?.data || { success: false };
  }
};

// 3) Current Subscription
export const fetchResidentSubscription = async (accessToken) => {
  const url = `${BASE_URL}/api/accounts/resident/payment/subscription/`;
  console.log("🛰️ [fetchResidentSubscription] GET", url);
  console.log("🔐 token:", accessToken);

  try {
    const res = await axiosInstance.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    console.log("🟩 [fetchResidentSubscription] response:", res.data);
    return res.data;
  } catch (error) {
    console.error(
      "🟥 [fetchResidentSubscription] error:",
      error.response?.data || error,
    );
    return error.response?.data || { success: false };
  }
};

// 4) Payment History
export const fetchPaymentHistory = async (accessToken) => {
  const url = `${BASE_URL}/api/accounts/resident/payment/history/`;
  console.log("🛰️ [fetchPaymentHistory] GET", url, "token?", !!accessToken);

  try {
    const config = accessToken
      ? { headers: { Authorization: `Bearer ${accessToken}` } }
      : undefined; // let axiosInstance interceptor inject it

    const response = await axiosInstance.get(url, config);
    console.log("🟩 [fetchPaymentHistory] response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "🟥 [fetchPaymentHistory] error:",
      error.response?.data || error,
    );
    return { success: false, data: [], message: "Failed to fetch" };
  }
};
